// Lightweight i18n with DE + EN
export const translations = {
  de: {
    appName: "Apotheken RMS",
    appSub: "Retouren-Verwaltung",
    nav: {
      dashboard: "Dashboard",
      returns: "Retouren",
      users: "Benutzer",
      audit: "Audit-Log",
      settings: "Einstellungen",
      profile: "Profil",
      logout: "Abmelden",
      login: "Anmelden",
      register: "Registrieren",
      impressum: "Impressum",
      privacy: "Datenschutz",
    },
    login: {
      title: "Anmelden",
      subtitle: "Greifen Sie auf Ihr Retouren-Management zu",
      identifier: "Email oder Benutzername",
      password: "Passwort",
      submit: "Anmelden",
      noAccount: "Noch kein Konto?",
      registerLink: "Konto beantragen",
    },
    register: {
      title: "Konto beantragen",
      subtitle: "Erstellen Sie einen neuen Zugang",
      email: "Email",
      username: "Benutzername",
      name: "Name",
      password: "Passwort",
      submit: "Konto beantragen",
      haveAccount: "Bereits ein Konto?",
      loginLink: "Anmelden",
      pendingMsg: "Konto erfolgreich beantragt. Ein Administrator muss Ihr Konto erst freischalten.",
    },
    dashboard: {
      title: "Dashboard",
      welcome: "Willkommen zurück",
      total: "Retouren gesamt",
      newReturn: "Neue Retoure",
      recent: "Neueste Retouren",
      viewAll: "Alle anzeigen",
      empty: "Noch keine Retouren erfasst",
    },
    stats: {
      Eingetroffen: "Eingetroffen",
      "In Bearbeitung": "In Bearbeitung",
      "Erneut versendet": "Erneut versendet",
      Storniert: "Storniert",
      Abgeschlossen: "Abgeschlossen",
    },
    returns: {
      title: "Retouren",
      search: "Suchen (Kunde, Bestellnummer, RET-ID, PZN)…",
      filter: "Status filtern",
      all: "Alle Status",
      new: "Neue Retoure",
      bulk: "Markierte abschließen",
      selected: "ausgewählt",
      empty: "Keine Retouren gefunden",
      cols: {
        id: "Retoure-ID",
        order: "Bestellnr.",
        customer: "Kunde",
        shop: "Shop",
        status: "Status",
        created: "Erstellt",
      },
    },
    form: {
      title: "Retouren-Details",
      orderNumber: "Bestellnummer",
      customerName: "Kundenname",
      customerNumber: "Kundennummer",
      address: "Anschrift (Straße, PLZ, Ort)",
      shopOrigin: "Shop-Herkunft",
      selectShop: "Shop wählen",
      articleInfo: "Artikel (PZN, Artikelnr. oder Name)",
      articlesLabel: "Artikel der Retoure",
      articleSingular: "Artikel",
      articlePlural: "Artikel",
      addArticle: "Artikel hinzufügen",
      removeArticle: "Artikel entfernen",
      quantity: "Menge & Beschreibung",
      storage: "Lagerplatz",
      storageQuick: "Standard: Ware ins Lager gelegt",
      tracking: "Sendungsnummer",
      status: "Status",
      photos: "Fotos der Ware",
      photoUpload: "Foto aufnehmen / hochladen",
      comments: "Interne Kommentare",
      commentPlaceholder: "Notiz hinzufügen…",
      addComment: "Hinzufügen",
      save: "Speichern",
      saveNew: "Retoure anlegen",
      cancel: "Abbrechen",
      locked: "Diese Retoure ist abgeschlossen und schreibgeschützt.",
      lockedAdmin: "Diese Retoure ist abgeschlossen. Sie können sie als Admin bearbeiten.",
      backToList: "Zurück zur Liste",
      deletePhoto: "Foto löschen",
    },
    users: {
      title: "Benutzerverwaltung",
      cols: { name: "Name", email: "Email", username: "Benutzername", role: "Rolle", status: "Status", created: "Erstellt", actions: "Aktionen" },
      approve: "Freischalten",
      block: "Sperren",
      unblock: "Entsperren",
      delete: "Löschen",
      reset: "Passwort zurücksetzen",
      makeAdmin: "Zum Admin machen",
      makeEmployee: "Zum Mitarbeiter machen",
      newPassword: "Neues Passwort",
      confirmDelete: "Benutzer wirklich löschen?",
      statuses: { pending: "Offen", active: "Aktiv", blocked: "Gesperrt" },
      roles: { admin: "Administrator", employee: "Mitarbeiter" },
    },
    profile: {
      title: "Mein Profil",
      name: "Name",
      email: "Email",
      username: "Benutzername",
      currentPassword: "Aktuelles Passwort",
      newPassword: "Neues Passwort (optional)",
      save: "Speichern",
      updated: "Profil aktualisiert",
    },
    audit: {
      title: "Audit-Log",
      cols: { timestamp: "Zeit", user: "Benutzer", action: "Aktion", target: "Objekt", details: "Details" },
      empty: "Keine Einträge",
      clear: "Alle löschen",
      clearConfirm: "Alle Audit-Log-Einträge wirklich löschen?",
      delete: "Eintrag löschen",
    },
    settings: {
      title: "Einstellungen",
      logo: "Logo",
      logoCurrent: "Aktuelles Logo",
      uploadLogo: "Logo hochladen (PNG/SVG)",
      removeLogo: "Logo entfernen",
      shopOrigins: "Shop-Herkünfte",
      addShop: "Shop hinzufügen",
      shopName: "Shop-Name",
      legal: "Rechtliche Inhalte",
    },
    cookie: {
      message: "Diese Anwendung verwendet ausschließlich essentielle Session-Cookies zur Aufrechterhaltung Ihres Logins. Weitere Informationen finden Sie in unserer",
      privacyLink: "Datenschutzerklärung",
      accept: "Verstanden",
    },
    legal: {
      impressumTitle: "Impressum",
      privacyTitle: "Datenschutzerklärung",
      placeholder: "Dieser Inhalt ist ein Platzhalter und kann durch einen Administrator angepasst werden.",
    },
    footer: "Made with",
    footerCity: "in Düsseldorf by",
    common: {
      loading: "Lädt…",
      saved: "Gespeichert",
      error: "Fehler",
      yes: "Ja",
      no: "Nein",
      confirm: "Bestätigen",
      sessionExpired: "Sitzung abgelaufen – bitte erneut anmelden",
    },
    actions: {
      openEdit: "Öffnen / Bearbeiten",
      changeStatus: "Status ändern",
      delete: "Löschen",
      deleteConfirmTitle: "Retoure löschen?",
      deleteConfirmDesc: "Diese Aktion kann nicht rückgängig gemacht werden. Die Retoure inkl. Fotos und Kommentare wird endgültig entfernt:",
    },
  },
  en: {
    appName: "Pharmacy RMS",
    appSub: "Return Management",
    nav: {
      dashboard: "Dashboard",
      returns: "Returns",
      users: "Users",
      audit: "Audit Log",
      settings: "Settings",
      profile: "Profile",
      logout: "Sign out",
      login: "Sign in",
      register: "Register",
      impressum: "Imprint",
      privacy: "Privacy Policy",
    },
    login: {
      title: "Sign in",
      subtitle: "Access your return management system",
      identifier: "Email or Username",
      password: "Password",
      submit: "Sign in",
      noAccount: "No account yet?",
      registerLink: "Request access",
    },
    register: {
      title: "Request access",
      subtitle: "Create a new account",
      email: "Email",
      username: "Username",
      name: "Name",
      password: "Password",
      submit: "Request access",
      haveAccount: "Already have an account?",
      loginLink: "Sign in",
      pendingMsg: "Account successfully requested. An administrator must first approve it.",
    },
    dashboard: {
      title: "Dashboard",
      welcome: "Welcome back",
      total: "Total returns",
      newReturn: "New return",
      recent: "Recent returns",
      viewAll: "View all",
      empty: "No returns yet",
    },
    stats: {
      Eingetroffen: "Arrived",
      "In Bearbeitung": "In progress",
      "Erneut versendet": "Reshipped",
      Storniert: "Cancelled",
      Abgeschlossen: "Completed",
    },
    returns: {
      title: "Returns",
      search: "Search (customer, order #, RET-ID, PZN)…",
      filter: "Filter status",
      all: "All statuses",
      new: "New return",
      bulk: "Mark selected completed",
      selected: "selected",
      empty: "No returns found",
      cols: { id: "Return ID", order: "Order #", customer: "Customer", shop: "Shop", status: "Status", created: "Created" },
    },
    form: {
      title: "Return details",
      orderNumber: "Order number",
      customerName: "Customer name",
      customerNumber: "Customer number",
      address: "Address (street, ZIP, city)",
      shopOrigin: "Shop origin",
      selectShop: "Select shop",
      articleInfo: "Article (PZN, article #, or name)",
      articlesLabel: "Return articles",
      articleSingular: "article",
      articlePlural: "articles",
      addArticle: "Add article",
      removeArticle: "Remove article",
      quantity: "Quantity & description",
      storage: "Storage location",
      storageQuick: "Default: returned to warehouse",
      tracking: "Tracking number",
      status: "Status",
      photos: "Item photos",
      photoUpload: "Take / upload photo",
      comments: "Internal comments",
      commentPlaceholder: "Add a note…",
      addComment: "Add",
      save: "Save",
      saveNew: "Create return",
      cancel: "Cancel",
      locked: "This return is completed and read-only.",
      lockedAdmin: "This return is completed. You can edit it as admin.",
      backToList: "Back to list",
      deletePhoto: "Delete photo",
    },
    users: {
      title: "User management",
      cols: { name: "Name", email: "Email", username: "Username", role: "Role", status: "Status", created: "Created", actions: "Actions" },
      approve: "Approve",
      block: "Block",
      unblock: "Unblock",
      delete: "Delete",
      reset: "Reset password",
      makeAdmin: "Make admin",
      makeEmployee: "Make employee",
      newPassword: "New password",
      confirmDelete: "Really delete this user?",
      statuses: { pending: "Pending", active: "Active", blocked: "Blocked" },
      roles: { admin: "Administrator", employee: "Employee" },
    },
    profile: {
      title: "My profile",
      name: "Name",
      email: "Email",
      username: "Username",
      currentPassword: "Current password",
      newPassword: "New password (optional)",
      save: "Save",
      updated: "Profile updated",
    },
    audit: {
      title: "Audit log",
      cols: { timestamp: "Time", user: "User", action: "Action", target: "Target", details: "Details" },
      empty: "No entries",
      clear: "Delete all",
      clearConfirm: "Really delete all audit log entries?",
      delete: "Delete entry",
    },
    settings: {
      title: "Settings",
      logo: "Logo",
      logoCurrent: "Current logo",
      uploadLogo: "Upload logo (PNG/SVG)",
      removeLogo: "Remove logo",
      shopOrigins: "Shop origins",
      addShop: "Add shop",
      shopName: "Shop name",
      legal: "Legal content",
    },
    cookie: {
      message: "This application uses only essential session cookies to keep you signed in. For details, see our",
      privacyLink: "Privacy Policy",
      accept: "Got it",
    },
    legal: {
      impressumTitle: "Imprint",
      privacyTitle: "Privacy Policy",
      placeholder: "This content is a placeholder and can be edited by an administrator.",
    },
    footer: "Made with",
    footerCity: "in Düsseldorf by",
    common: { loading: "Loading…", saved: "Saved", error: "Error", yes: "Yes", no: "No", confirm: "Confirm", sessionExpired: "Session expired – please sign in again" },
    actions: {
      openEdit: "Open / edit",
      changeStatus: "Change status",
      delete: "Delete",
      deleteConfirmTitle: "Delete return?",
      deleteConfirmDesc: "This action cannot be undone. The return incl. photos and comments will be permanently removed:",
    },
  },
};
